<template>
  <div class="point_page">
		<div class="point_title">
			<div class="title">{{ L['我的积分'] }}</div>
		</div>

    <div class="point_card_part">
      <div class="card">
        <div class="title">当前有效积分</div>
        <div class="point">{{pointData.totalIntegral}}</div>
      </div>
      <div class="line"></div>
      <div class="card">
        <div class="title">即将过期的积分<span>（{{pointData.expiringSoonDays}}天内）</span></div>
        <div class="point">{{pointData.expiringSoonIntegral}}</div>
      </div>
    </div>

    <div class="point_list_title">积分明细</div>
    <div class="point_list_line"></div>

    <div class="pont_list">
      <div class="point_list_sub">
        <div class="title_date">{{ L['日期'] }}</div>
        <div class="title_line"></div>
        <div class="title_points">{{ L['积分变动'] }}</div>  
        <div class="title_line"></div>     
        <div class="title_des">{{ L['说明'] }}</div>
      </div>
    </div>	

    <div v-if="integrallogs.data && integrallogs.data.pagination && integrallogs.data.pagination.total" class="point_list_list">
      <div v-for="(item, index) in integrallogs.data.list" class="list_line" >
        <div class="list_item item_date">{{ item. createTime}}</div>
        <div class="list_item item_points" :style="'color: ' + (item.inOutType == 1 ? '#DF443B;' : '#000000;')">{{(item.inOutType == 1 ? '+' : '-') +  item.value}}<span v-if="item.isFrozen">(冻结)</span></div>
        <div class="list_item item_des">{{ item. description}}</div>
      </div>
    </div>
    <SldCommonEmpty
        v-else
        totalHeight="587"
        totalWidth="1003"
        tip="暂无积分记录~"
    />


    <div class="flex_row_center sld_pagination sld_page_bottom" v-if="integrallogs.data && integrallogs.data.pagination && integrallogs.data.pagination.total ">
      <el-pagination @current-change="handleCurrentChange" v-model:currentPage="current" :page-size="pageSize"
        layout="prev, pager, next" :total="integrallogs.data.pagination.total" :hide-on-single-page="true">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import MemberTitle from '../../components/MemberTitle'
import SldCommonEmpty from '../../components/SldCommonEmpty'
import { reactive, onMounted, getCurrentInstance, ref } from 'vue'
export default {
  name: 'myPoint',
  components: {
    MemberTitle,
    SldCommonEmpty
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const pageSize = ref(10)
    const current = ref(1)
    const integrallogs = reactive({ data: {list:[]} }) 
    const params = reactive({
      current: 1,
      pageSize: 10,
    })
    const pointData = ref({}) 

    const getInitPoint = () => {
      proxy.$get('v3/member/front/integralLog/getMemberIntegral').then(res => {
        console.log("getInitPoint===",res)
        if (res.state == 200) {
          pointData.value = res.data
        }
        console.log("getInitPoint===",pointData)
      })
    }
    const getPointList = () => {
      proxy.$post('/v3/member/front/integralLog/list', params).then(res => {
        if (res.state == 200) {
          integrallogs.data = res.data
        }
      })
    }

    const handleCurrentChange = e => {
      params.current = e
      getPointList()
    }

    onMounted(() => {
      getInitPoint()
      getPointList()
    })

    return {
      L,
      handleCurrentChange,
      integrallogs,
      pageSize,
      current,
      pointData
    }
  }
}
</script>
<style lang="scss">
@import '@/style/myPoint.scss';
@import '../../style/base.scss';
@import '../../style/iconfont.css';
.sld_pagination {
  margin-right: 40px;
  margin-bottom: 20px;
}
</style>
